<template>
    <div class="page-cabinet-profile-card">
        <div class="page-cabinet-profile-card__title"
            v-text="title"
        />
        <ui-card-base>
            <div class="page-cabinet-profile-card__container">
                <slot />
            </div>
        </ui-card-base>
    </div>
</template>

<script>
export default {
    name: 'page-cabinet-profile-card',
    props: {
        title: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-profile-card {
    width: 100%;
    &__title {
        .typography-heading();

        margin-bottom: 16px;
        margin-left: 24px;
    }
    &__container {
        padding: 8px;
    }
    @media @media-md-down {
        &__title {
            margin-left: 16px;
        }
        &__container {
            padding: 0;
        }
    }
}
</style>
